<div class="container animated fadeInRight">
  
    <!--<app-card [innTemplate]="requisicion" [titulo]="'BUSCAR'" [efecto]="true"
      [colapseName]="'requisicion'" [banderaColapse]='true'></app-card>
      <ng-template #requisicion>
        
          <div class="row">
            <div [class]="'col-md-4'">
              <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter " (keyup)="onQuickFilterChanged() " #quickFilter/>
            </div>
            
          </div>
       
        <br>
      </ng-template>-->
    

    <app-lfsa-card *ngIf="mostrarCard" [innTemplate]="datosRequisicion" [titulo]="'REPORTE EMPLEADOS'" [efecto]="true"></app-lfsa-card>
    <ng-template #datosRequisicion>
      <div class="row">
        <div [class]="'col-md-4'">
          <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter " (keyup)="onQuickFilterChanged() " #quickFilter/>
        </div>
        
      </div>
      <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <div *ngIf="!loading">
      <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
        No existen datos para la lista de Reporte.
      </div>
      <ag-grid-angular *ngIf="!listaVacia" #agGrid class=" {{empModulo.agGrid.class}}"
        [ngStyle]="empModulo.agGrid.style" id="{{empModulo.agGrid.id}}" [frameworkComponents]="frameworkComponents "
        [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)"
        [pagination]="true" [paginationPageSize]="empModulo.agGrid.paginacion">
      </ag-grid-angular>
    </div>
    <br>
    </ng-template>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <div *ngIf="!loading" class="row">
      <div class="form-group col-md-6">
        <button [routerLink]="['/emp/administrador/home-emp']" class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
      </div>
      <div class="form-group col-md-6">
        <button [routerLink]="['/emp/administrador/home-emp']"  class="btn btn-success btn-block btn-lg" (click)="downloadEmpleadosExcel()">Descargar</button>
      </div>
      
    </div>
  
</div>



<!-- {{ rowData | json }} -->
<br>